import { ICellFormat } from '@modeso/types__aumico-lib-core-be';
import { SuperTableColumnType } from '@modeso/types__aumico-lib-notes-be';
import { SuperTableColumnBelongingYear } from '@modeso/types__aumico-lib-notes-be/dist/models/enums/super_table_column_belonging_year.enum';
import { SuperTableColumnWidth } from '../enums/SuperTableColumnWidth.ebum';

export interface INotesSuperTableColumnForPrintPreview {
    columnId: string;
    columnTitle: string;
    type: SuperTableColumnType;
    belongingYear?: SuperTableColumnBelongingYear;
    isRatio?: boolean;
    format?: ICellFormat;
    columnWidth?: SuperTableColumnWidth;
}
